import type { ParamMatcher } from '@sveltejs/kit';

/**
 * Determines if the provided parameter matches the allowed values.
 *
 * @param param - The parameter to be checked.
 * @returns `true` if the parameter is included in the allowed list, otherwise `false`.
 */
export const match: ParamMatcher = (param: string): boolean => ['login'].includes(param);
